"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var AsherPage_1 = require("./../Common/parts/AsherPage");
var AsherDisclousure_1 = require("./../Common/parts/AsherDisclousure");
var AsherStudenInformation_1 = require("./../Common/parts/AsherStudenInformation");
var AsherProgram_1 = require("./../Common/parts/AsherProgram");
var styles = __importStar(require("./../Common/Common.module.css"));
var stylesEnroll = __importStar(require("./EnrollmentTransfer.module.css"));
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data, errors: model.errors };
}
var EnrollmentTransfer = (function (_super) {
    __extends(EnrollmentTransfer, _super);
    function EnrollmentTransfer(props) {
        var _this = _super.call(this, props) || this;
        _this.getNextForm = _this.getNextForm.bind(_this);
        _this.changeState = _this.changeState.bind(_this);
        _this.getNextStudentForm = _this.getNextStudentForm.bind(_this);
        return _this;
    }
    EnrollmentTransfer.prototype.getNextForm = function () {
        var campusState = this.props.json_data["campusState"] || "CA";
        switch (campusState) {
            case "CA":
                return "schoolOfficialSignatureFactSheet";
                break;
            case "NV":
                return "collegeRepresentativeSignature";
                break;
            case "TX":
                return "certifySchoolOfficialSignature";
                break;
        }
    };
    EnrollmentTransfer.prototype.getNextStudentForm = function () {
        var campusState = this.props.json_data["campusState"] || "CA";
        switch (campusState) {
            case "CA":
                return "completionRatesInitials";
                break;
            case "NV":
                return "performanceStudentSignature";
                break;
            case "TX":
                return "AttendanceStudentSignature";
                break;
        }
    };
    EnrollmentTransfer.prototype.render = function () {
        var errors = !!Object.keys(this.props.errors).length;
        var campusState = this.props.json_data["campusState"] || "CA";
        var isPdf = false;
        if (window.isPdf) {
            isPdf = true;
        }
        return (react_1.default.createElement("div", { id: "asher_enrollment_agreement_transfer", className: stylesEnroll.agreementPosition },
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
            react_1.default.createElement(AsherPage_1.AsherPage, { state: campusState, pageNumber: 1, totalPages: 1, classNameWrap: errors ? styles.pageSizeErrors : styles.pageSize, nextInputId: this.getNextStudentForm() },
                react_1.default.createElement(AsherStudenInformation_1.AsherStudentInformation, null),
                react_1.default.createElement(AsherProgram_1.AsherStudentProgram, { state: campusState }),
                react_1.default.createElement(AsherDisclousure_1.AsherStudentDisclousure, { state: campusState, nextForm: this.getNextForm() }))));
    };
    EnrollmentTransfer.prototype.changeState = function (changeEvent) {
        this.setState({
            stateSelected: changeEvent.target.value
        });
    };
    return EnrollmentTransfer;
}(react_1.Component));
exports.EnrollmentTransfer = EnrollmentTransfer;
exports.AsherEnrollmentTransfer = react_redux_1.connect(mapStateToProps)(EnrollmentTransfer);
//# sourceMappingURL=data:application/json;base64,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